import React from 'react';
import { PapiAttachmentFile, PapiDeviation } from '@wix/da-papi-types';
import MainThumb from '../../../layouts/common/MainThumb/MainThumb';
import SortableAttachmentThumbSlider from '../../../layouts/common/SortableAttachmentThumbSlider/SortableAttachmentThumbSlider';

import s from './PreviewThumbs.scss';

interface Props {
  deviation: PapiDeviation;
  isUploading?: boolean;
  selectedAttachmentId?: number;
  onSelectAttachment: (attachment?: PapiAttachmentFile) => void;
  onAttachmentAdded?: (
    attachment: PapiAttachmentFile,
    deviation: PapiDeviation
  ) => void;
  onRemoveAttachment?: (fileId: number) => void;
}

const PreviewThumbs: React.FC<Props> = ({
  deviation,
  isUploading = false,
  selectedAttachmentId,
  onSelectAttachment,
  onAttachmentAdded,
  onRemoveAttachment,
}) => {
  return (
    <div className={s['root']}>
      <MainThumb
        className={s['main-thumb']}
        item={deviation}
        onClick={() => onSelectAttachment(undefined)}
        selected={!selectedAttachmentId}
      />
      <div className={s['separator']} />
      <SortableAttachmentThumbSlider
        className={s['thumbs-slider']}
        deviation={deviation}
        selectedItemId={selectedAttachmentId}
        onItemClick={onSelectAttachment}
        isUploading={isUploading}
        removeAttachment={onRemoveAttachment}
        onAttachmentAdded={onAttachmentAdded}
      />
    </div>
  );
};
PreviewThumbs.displayName = 'PreviewThumbs';

export default PreviewThumbs;
